import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const ActivityLine = styled.line`
  stroke-width: 1.2px;
  animation: 0.1s linear 1 ${fadeIn};
  stroke: var(--theme-neutral-200);
  cursor: pointer;
`;

export const AlertLine = styled(ActivityLine)`
  stroke: var(--theme-warning-600);
`;

export const ActivityCircle = styled.circle`
  fill: var(--theme-warning-600);
`;
